import { Plugin } from "../../helper/plugins/redux-core-plugin";

//STEP: 1 - Create Fetcher

export const { fetcher: fetchKycReducer, fetchKyc } = Plugin("fetchKyc", {
  method: "GET",
  apiEndpoint: `/admin/kyc/PENDING?limit=30&skip=0`,
  withCredentials: true,
});
